import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useStore } from '@/store';
import { getFac, getDeviceGroupMyFocusDetail } from '@/service/production/equipmentLive';
export default function useGuliaoList() {
  var store = useStore();
  var list1 = ref([]);
  var list2 = ref([]);
  var showLoading = ref(false);
  var type = ref('');
  var groupID = computed(function () {
    return store.getters['production/deviceGroupId'];
  });
  // 获取主机汇总数据
  var getFacAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _data$type, data, _data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            list1.value = []; // 关注或设备列表
            list2.value = []; // 温度列表
            showLoading.value = true;
            // 如果groupID不存在则 获取关注的设备列表， 存在则获取对应groupID的设备列表或温度列表数据
            if (!groupID.value) {
              _context.next = 13;
              break;
            }
            _context.next = 7;
            return getFac({
              groupNo: groupID.value
            });
          case 7:
            data = _context.sent;
            type.value = (_data$type = data.type) !== null && _data$type !== void 0 ? _data$type : '';
            if (data.type == 'temp') {
              // 如果是温度
              list2.value = _toConsumableArray(data.list);
            } else {
              // 不是温度，则是设备列表
              list1.value = _toConsumableArray(data.list);
            }
            store.commit('production/updateDeviceGroup', data.list);
            _context.next = 20;
            break;
          case 13:
            type.value = '';
            // 当前菜单项索引为0
            store.commit('production/updateSiderbarIndex', 0);
            // 获取关注的设备列表
            _context.next = 17;
            return getDeviceGroupMyFocusDetail();
          case 17:
            _data = _context.sent;
            list1.value = _toConsumableArray(_data.list);
            store.commit('production/updateDeviceGroup', _data.list);
          case 20:
            _context.next = 25;
            break;
          case 22:
            _context.prev = 22;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 25:
            _context.prev = 25;
            showLoading.value = false;
            return _context.finish(25);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 22, 25, 28]]);
    }));
    return function getFacAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  // 监听左侧菜单发生改变，左侧菜单切换时，groupID会发生改变，需要去请求对应菜单的数据
  watch(groupID, function () {
    console.log('grounpId发生了改变', groupID);
    getFacAsync();
  });
  return [list1, list2, type, showLoading, getFacAsync];
}